import {
    DISPATCH_ADMIN_DATA_UPDATE,
    DISPATCH_ADMIN_DATA_UPDATE_SUCCESS,
    DISPATCH_ADMIN_DATA_UPDATE_FAILURE,
    CLEAR_ADMIN_DATA_UPDATE_STATUS,
} from './constants';

export const clearAdminDataUpdateStatus = () => ({
    type: CLEAR_ADMIN_DATA_UPDATE_STATUS,
});

export const dispatchAdminDataUpdate = () => ({
    type: DISPATCH_ADMIN_DATA_UPDATE,
    payload: {},
});

export const dispatchAdminDataUpdateSuccess = (status, dispatchAdminDataUpdateEstimatedEndTime) => ({
    type: DISPATCH_ADMIN_DATA_UPDATE_SUCCESS,
    payload: { status, dispatchAdminDataUpdateEstimatedEndTime },
});
export const dispatchAdminDataUpdateFailure = (error, dispatchAdminDataUpdateEstimatedEndTime = null) => ({
    type: DISPATCH_ADMIN_DATA_UPDATE_FAILURE,
    payload: { message: error, dispatchAdminDataUpdateEstimatedEndTime },
});